var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelay = function SvgDelay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23 15.75a.75.75 0 0 0 0-1.5zm-8.283-5.026L14 10.94zM5.58 12.342l2.265-7.548-1.437-.431-2.264 7.548zm6.575-7.548L14 10.94l1.437-.431-1.844-6.146zm8.31 10.956H23v-1.5h-2.536zm-6.466-4.81a6.75 6.75 0 0 0 6.465 4.81v-1.5a5.25 5.25 0 0 1-5.028-3.741zM7.845 4.794c.641-2.138 3.669-2.138 4.31 0l1.437-.431c-1.07-3.564-6.115-3.564-7.184 0zM1 15.75a4.78 4.78 0 0 0 4.58-3.408l-1.436-.431A3.28 3.28 0 0 1 1 14.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 14.25a.75.75 0 0 0 0 1.5zm0 1.5h2.536v-1.5H1zm9.001-4.81 1.844-6.146-1.437-.431-1.844 6.146zm6.154-6.146 2.265 7.548 1.436-.431-2.264-7.548zm2.265 7.548A4.78 4.78 0 0 0 23 15.75v-1.5c-1.45 0-2.727-.95-3.144-2.339zm-6.575-7.548c.641-2.138 3.669-2.138 4.31 0l1.437-.431c-1.07-3.564-6.115-3.564-7.184 0zM3.535 15.75a6.75 6.75 0 0 0 6.466-4.81l-1.437-.431a5.25 5.25 0 0 1-5.028 3.741z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1 21h22"
  })));
};
export default SvgDelay;